import React, { useState } from "react";
import { Tabs, Tab, Paper } from "@material-ui/core";
import { UserProfile } from "api/user";
import { Club } from "api/clubs";
import i18n from "./i18n";
import UserProfileTab from "./UserProfileTab";
import PrivacyTab from "./PrivacyTab";
import AliasAccountsTab from "./AliasAccountsTab";

// prop types
interface ProfileViewProps {
    club: Club | null,
    userProfile: UserProfile | null,
    onFetchUserProfile: () => void,
    onSignOut: () => void,
}

// user profile stuff
const ProfileView = ({ club, userProfile, onFetchUserProfile, onSignOut }: ProfileViewProps) => {
    // ui state
    const [currentTab, setCurrentTab] = useState(0);
    const isCompany = club?.capabilities.includes("company");

    // render
    return (
        <>
            <Paper style={{ display: "flex", justifyContent: "space-between" }}>
                {/* tabs */}
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    value={currentTab}
                    onChange={(e, index) => setCurrentTab(index)}
                >
                    <Tab label={i18n.userProfile} />
                    <Tab label={i18n.privacy} />
                    {!userProfile?.isAlias && !isCompany && <Tab label={i18n.aliasAccounts} />}
                </Tabs>
            </Paper>
            {currentTab === 0 && <UserProfileTab userProfile={userProfile} onFetchUserProfile={onFetchUserProfile} onSignOut={onSignOut} />}
            {currentTab === 1 && <PrivacyTab club={club} />}
            {currentTab === 2 && !isCompany && <AliasAccountsTab clubId={club?.id} userProfile={userProfile} />}
        </>
    );
};

export default ProfileView;
